<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增菜单</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="title" label="菜单名称" min-width="100"></el-table-column>
            <el-table-column prop="name" label="路由名称" min-width="100"></el-table-column>
            <el-table-column prop="path" label="菜单路由" min-width="100"></el-table-column>
            <el-table-column prop="icon" label="菜单图标" min-width="100">
                <template slot-scope="scope">
                    <i v-if="scope.row.icon.startsWith('el-')" :class="scope.row.icon"></i>
                    <i v-else class="iconfont" :class="scope.row.icon"></i>
                </template>
            </el-table-column>
            <el-table-column prop="sort" label="菜单排序" min-width="100"></el-table-column>
            <el-table-column prop="status" label="状态" min-width="100">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.status==1">开启</el-tag>
                    <el-tag type="info" v-else>关闭</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增菜单':'修改菜单'" :visible.sync="NewData.NewBlon" width="25%" class="BorderRadius">
            <div class="DigItem">
                <div class="DigItemTit">菜单名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入菜单名称" v-model="NewData.title"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">路由名称：</div>
                <el-input class="Wid" size="medium" placeholder="请输入菜单路由" v-model="NewData.name"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">菜单路由：</div>
                <el-input class="Wid" size="medium" placeholder="请输入菜单路由" v-model="NewData.path"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">菜单图标：</div>
                <el-input class="Wid" size="medium" placeholder="请输入菜单图标" v-model="NewData.icon"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">菜单排序：</div>
                <el-input class="Wid" size="medium" placeholder="请输入菜单排序" v-model="NewData.sort"></el-input>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="NewData.NewBlon = false">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="Suc">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    title:"",
                    path:"",
                    name:"",
                    icon:"",
                    sort:"",
                    status:1,
                }
            };
        },
        mounted() {
            this.GetData();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/menu/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data;
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.title = row.title;
                    this.NewData.name = row.name;
                    this.NewData.path = row.path;
                    this.NewData.icon = row.icon;
                    this.NewData.sort = row.sort;
                    this.NewData.status = row.status;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            Suc(){
                if(this.Type=='Add'){
                    this.SucNew();
                }else{
                    this.SucEdit();
                }
            },
            SucEdit(){
                this.$put('/admin/menu/update/'+this.NewData.id,{
                    "parent_id":0,
                    "title": this.NewData.title,
                    "name": this.NewData.name,
                    "path": this.NewData.path,
                    "icon": this.NewData.icon,
                    "sort":this.NewData.sort,
                    "status": this.NewData.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功");
                        this.GetData();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            SucNew(row) {
                this.$post('/admin/menu/save',{
                    "parent_id":0,
                    "title": this.NewData.title,
                    "name": this.NewData.name,
                    "path": this.NewData.path,
                    "icon": this.NewData.icon,
                    "sort":this.NewData.sort,
                    "status": this.NewData.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("添加成功");
                        this.ReSetPage();
                        this.$Tools.ResetData(this.NewData)
                    }
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该菜单, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/menu/delete/'+id).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    
</style>
